import React from 'react';
import { Routes, Route } from 'react-router-dom';
// 本番ページ (ログイン関連)
import SignIn from '../Page/Login/SignIn/SignIn';
import SignUp from '../Page/Login/SignUp/SignUp';
import SignOut from '../Page/Login/SignOut/SignOut';
import ResetPassword from '../Page/Login/ResetPassword/ResetPassword';

// 投稿ページ
import Post from '../Page/Post/Post';
import PostDetail from '../Page/Post/PostDetail';
// 道具保管ページ
import Tools from '../Page/Tools/Tools';
import ToolList from '../Page/Tools/ToolList';
import Settings from '../Page/Settings/Settings';
import PostSettings from '../Page/Settings/PostSettings';
import ToolSettings from '../Page/Settings/ToolSettings';
import ToolDetail from '../Page/Tools/ToolDetail';
import ToolEdit from '../Page/Tools/ToolEdit';
import ToolReplace from '../Page/Tools/ToolReplace';
import Home from '../Page/Home/Home';
import Profile from '../Page/Profile/Profile';
const Simple = ({ title }) => <div style={{ padding:24 }}>{title}</div>;
const About = () => <div style={{ padding:24 }}>アバウト画面</div>;
const NotFound = () => <div style={{ padding:24 }}>ページが見つかりません</div>;

function AppRouter() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/about" element={<About />} />
			<Route path="/profile" element={<Profile />} />
			<Route path="/settings" element={<Settings />} />
			<Route path="/settings/post" element={<PostSettings />} />
			<Route path="/settings/tool" element={<ToolSettings />} />
			<Route path="/post" element={<Post />} />
			<Route path="/post/detail/:id" element={<PostDetail />} />
			<Route path="/tools" element={<Tools />} />
			<Route path="/tools/list" element={<ToolList />} />
			<Route path="/tools/detail/:id" element={<ToolDetail />} />
			<Route path="/tools/edit/:id" element={<ToolEdit />} />
			<Route path="/tools/replace" element={<ToolReplace />} />
			<Route path="/signin" element={<SignIn />} />
			<Route path="/signout" element={<SignOut />} />
			<Route path="/signup" element={<SignUp />} />
			<Route path="/reset-password" element={<ResetPassword />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}

// 必要なら個別エクスポート (後で別ファイル化しても良い)
export default AppRouter;
export { Home, About, Settings, SignIn, SignOut, SignUp, NotFound };
